import React, {useState, useContext} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {AppContext} from "../../../context/context";
import { Modal, Box, Typography, TextField, Button, Link, Backdrop } from '@mui/material';
import useRegisterHandler from "../handlers/registerHandler";
import useLoginHandler from "../handlers/loginHandler";



const AuthModal = () => {
    const { t } = useTranslation('auth');
    const context = useContext(AppContext);
    const [password, setPassword] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);


    if (!context) {
        throw new Error("Auth Modal has to be used within the app context provider")
    }

    const {userData} = context;
    const {userDetails, setUserDetails} = userData;

    const isOpen = userDetails.userId === '';

    const registrationHandler = useRegisterHandler();
    const loginHandler = useLoginHandler();

    const [tempUsername, setTempUsername] = useState(userDetails.email)
    const [tempFullName, setTempFullName] = useState(userDetails.fullName)

    return (
  <Modal open={isOpen} onClose={() => {}} closeAfterTransition BackdropComponent={Backdrop}>
  <Box
    sx={{
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h5" sx={{ mb: 2 }}>
      {isRegistering ? t('loginModal.registerTitle') : t('loginModal.loginTitle')}
    </Typography>

    <TextField
      fullWidth
      label={t('loginModal.emailLabel')}
      type="email"
      variant="outlined"
      margin="normal"
      value={tempUsername}
      onChange={(e) => setTempUsername(e.target.value)} // setUserDetails({ ...userDetails, email: e.target.value })
    />

    <TextField
      fullWidth
      label={t('loginModal.passwordLabel')}
      type="password"
      variant="outlined"
      margin="normal"
      value={password}
      onChange={(e) => {setPassword(e.target.value)}} // setPassword(e.target.value)
    />

    {!isRegistering && (
      <Typography variant="body2" sx={{ textAlign: 'right', mt: 0.5 }}>
        <Link component={RouterLink} to="/forgot-password" underline="hover">
          {t('loginModal.forgotPassword')}
        </Link>
      </Typography>
    )}

    {isRegistering && (
      <TextField
        fullWidth
        label={t('loginModal.fullNameLabel')}
        type="text"
        variant="outlined"
        margin="normal"
        value={tempFullName}
        onChange={(e) => {setTempFullName(e.target.value)}} // setFullName(e.target.value)
      />
    )}

    <Button
      fullWidth
      variant="contained"
      color="primary"
      sx={{ mt: 2 }}
        onClick={async () => {
          try {
            if (isRegistering) {
              await registrationHandler(tempUsername, password, tempFullName);
            } else {
              await loginHandler(tempUsername, password);
            }
          } catch (error: any) {
            console.error(error.message); // or show toast / set error state
            alert(error.message);         // basic feedback for now
          }
        }}

    >
      {isRegistering ? t('loginModal.registerButton') : t('loginModal.loginButton')}
    </Button>

    <Typography sx={{ mt: 2 }} align="center">
      {isRegistering ? t('loginModal.registerPromptHasAccount') : t('loginModal.registerPromptNoAccount')}{' '}
      <Link
        href="#"
        onClick={() => setIsRegistering(!isRegistering)}
        underline="hover"
      >
        {isRegistering ? t('loginModal.switchToLogin') : t('loginModal.switchToRegister')}
      </Link>
    </Typography>
  </Box>
</Modal>

);



}

export default AuthModal



